import { useEffect, useState, createContext, useContext } from 'react';
import { Button, Input, Select, Space } from 'antd';
import CustomerService from "services/customer"
import { formatCurrency } from "utils/number"
import { UserAddOutlined, SolutionOutlined, EditOutlined } from "@ant-design/icons"
import AddressEdit from "./Popup"
const service = new CustomerService();
const AddressPickerContext = createContext();
const CustomerPicker = (props) => {
    const [customers, setCustomers] = useState([]);
    const [showAddCustomer, setShowAddCustomer] = useState(false)
    const [address, setAddress] = useState(false);
    useEffect(() => {
      
    }, []);
    useEffect(() => {
        var a = props.value ?? {};
    
        setAddress(`${a.phone_number??""} ${a.full_name??""} ${a.address??""}`)
    }, [props.value])


    const onChange = (e) => {
        console.log(e);
        props.onChange(e);
        var cus = customers.find(x => x.id == e);
        if (cus) {
            props.onCustomerChange(cus);
        }
    }

    return (
        <>
            <AddressPickerContext.Provider value={{ address: props.value , onChange :  props.onChange, customer_id: props.customer_id }}>
                <div style={{ display: "flex", gap: 8 }}>


                    <div style={{ flexGrow: 1 }}>


                        <Input value={address} contentEditable={false}></Input>
                    </div>

                    <div >
                        <Space>
                            <Button onClick={e => setShowAddCustomer(true)}><EditOutlined /></Button>


                        </Space>


                    </div>

                </div>
                <AddressEdit open={showAddCustomer} onClose={e => setShowAddCustomer(false)}></AddressEdit>
            </AddressPickerContext.Provider>
        </>
    )
}
const useAddressPicker = () => {
    return useContext(AddressPickerContext)
}
export { useAddressPicker }
export default CustomerPicker;